<template>
  <div class="home-components">
    <div class="home">
      <Carousel />
      <div class="stripe-void01">
      </div>
      <div class="stripe-void02">
      </div>
      <p class="main-catch mincho">
        僕らは、東京・神奈川で、ずっと。
      </p>
      <div class="link-wrapper">
        <div class="section-title">
          働き方
        </div>
        <div class="link-center-wrap">
          <MainPageLinkCard Link="/job#target01" mainCatch="向いている仕事が<br>わからない方へ" infoText="勤務地は「東京・神奈川」限定です。" :backImg="require('../assets/img/home/button_image01.jpg')" :isSmall="false" />
          <MainPageLinkCard Link="/job#target02" mainCatch="興味をもった仕事が<br>ある方へ" infoText="好きな職種を選べます。" :backImg="require('../assets/img/home/button_image02.jpg')" :isSmall="false" />
        </div>

        <div class="section-title">
          求める人物像／教育・研修
        </div>
        <div class="link-center-wrap">
          <MainPageLinkCard Link="/person" mainCatch="求める人物像" infoText="人と接するのが好きな方も、苦手な方も。" :backImg="require('../assets/img/home/button_image03.jpg')" :isSmall="false" />
          <MainPageLinkCard Link="/education" mainCatch="教育・研修について" infoText="あなたの可能性を見つけ出します。" :backImg="require('../assets/img/home/button_image04.jpg')" :isSmall="false" />
        </div>

        <div class="section-title">
          会社について／働きやすさ／Q&A
        </div>
        <div class="link-center-wrap">
          <MainPageLinkCard Link="/about" mainCatch="sanwaを知る" infoText="出店戦略やビジョンなどを公開！" :backImg="require('../assets/img/home/button_image05.jpg')" :isSmall="true" />
          <MainPageLinkCard Link="/welfare" mainCatch="福利厚生と社風など" infoText="安心して勤めていく上で大切なことって？" :backImg="require('../assets/img/home/button_image06.jpg')" :isSmall="true" />
          <MainPageLinkCard Link="/faq" mainCatch="疑問はここで解決！" infoText="「？」がある方は、こちらをご覧ください。" :backImg="require('../assets/img/home/button_image07.jpg')" :isSmall="true" />
        </div>

        <div class="section-title">
          仕事を知る
        </div>
        <div class="link-center-wrap">
          <KnowJobLinkCard Link="/job/grocery" mainCatch="グロサリー担当" :backImg="require('../assets/img/home/button_image08.jpg')" />
          <KnowJobLinkCard Link="/job/nousan" mainCatch="農産担当" :backImg="require('../assets/img/home/button_image09.jpg')" />
          <KnowJobLinkCard Link="/job/chikusan" mainCatch="畜産担当" :backImg="require('../assets/img/home/button_image10.jpg')" />
          <KnowJobLinkCard Link="/job/suisan" mainCatch="水産担当" :backImg="require('../assets/img/home/button_image11.jpg')" />
          <KnowJobLinkCard Link="/job/souzai" mainCatch="惣菜担当" :backImg="require('../assets/img/home/button_image12.jpg')" />
          <KnowJobLinkCard Link="/job/nippai" mainCatch="日配担当" :backImg="require('../assets/img/home/button_image13.jpg')" />
          <KnowJobLinkCard Link="/job/customer" mainCatch="お客様係担当" :backImg="require('../assets/img/home/button_image14.jpg')" />
          <div class="chedule_page_link_card">
            <router-link to="/schedule">
              <div class="card-main">
                <div class="image">
                  <img src="../assets/img/home/button_image15.jpg" alt="">
                </div>
                <div class="text">
                  <p class="catch">
                    一日のスケジュール
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from '@/components/home/Carousel.vue'
import MainPageLinkCard from '@/components/home/MainPageLinkCard.vue'
import KnowJobLinkCard from '@/components/home/KnowJobLinkCard.vue'
export default {
  name: 'Home',
  components: {
    Carousel,
    MainPageLinkCard,
    KnowJobLinkCard
  },
}
</script>
<style scoped lang="scss">
.home {
  padding-bottom: 100px;
  &:before {
    content: "";
    background-color: #f0f0f0;
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
  }
  &:after {
    content: "";
    background-color: #f0f0f0;
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
  }
}
.main-catch {
  font-size: 30px;
  text-align: center;
  margin-top: 50px;
  @media print, screen and (max-width: 930px) {
    font-size: 20px;
  }
}
.link-wrapper {
  margin: 0 auto;
  padding-top: 50px;
  max-width: 1300px;
}
.section-title {
  background-color: #ffce48;
  display: inline-block;
  padding: 0 100px;
  position: relative;
  z-index: 1;
  font-size: 14px;
  @media print, screen and (max-width: 930px) {
    padding: 0 50px;
  }
}
.link-center-wrap {
  margin: 0 auto;
  width: 100%;
  max-width: 930px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translateY(-10px);
}
.link-center-wrap + .section-title {
  margin-top: 100px;
}
.chedule_page_link_card {
  max-width: 230px;
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 3px;
  a {
    display: block;
    position: relative;
    &:after {
      content: "";
      width: 0%;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      background-color: #e51c57;
      transition: width 0.2s cubic-bezier(0.77, 0, 0.175, 1);
    }
    &:hover {
      opacity: 1;
      &:after {
        width: 100%;
      }
    }
  }
  .card-main {
    height: 160px;
    position: relative;
    .image {
      position: relative;
      img {
        vertical-align: middle;
      }
    }
    .text {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .catch {
        margin-top: 60px;
        z-index: 1;
        line-height: 2em;
        font-size: 12px;
        background-color: #000;
        color: #fff;
        width: 150px;
        text-align: center;
        border-radius: 10px;
      }
    }
  }
}
</style>
